<template>
  <div class="upload f-wrap">
    <div class="add-file item-size">
      <input class="upload-input" accept="image/*" required type="file" @change="uploadFile" />
    </div>
    <div class="file-item item-size" v-for="(file, index) in files" :key="index">
      <img class="image" :src="file.validUrl" />
    </div>
  </div>
</template>

<script>
import { ref, reactive, onMounted, watch } from 'vue'
import { fileApi } from '@/apis'
import { toast, loadingCreate } from '@/utils/alert'
import * as qiniu from '@/utils/qiniu'
export default {
  props: {
    files: {
      type: Array,
      default: [],
    },
  },
  setup(props, { emit }) {
    const fileToServer = async (file) => {
      const loading = await loadingCreate('资料上传中...')
      try {
        const pubAuth = await fileApi.getPrivateAuth()
        const qiniuData = await qiniu.putbFile(
          file,
          Math.random().toString(36).slice(-16),
          pubAuth
        )
        console.log('qiniuData', qiniuData)
        const data = await fileApi.save({
          bucket: qiniuData.bucket,
          mimeType: qiniuData.mimeType,
          saveName: qiniuData.saveName,
          upName: qiniuData.upName,
          format: qiniuData.format,
        })
        data.validUrl = await fileApi.getValidUrl({ id: data.id })

        return data
      } catch (error) {
        if (/limited mimeType/.test(error.data.error)) {
          toast('上传文件仅支持，jpg、png的图片格式')
        }
      } finally {
        loading.dismiss()
      }
    }

    const uploadFile = async (e) => {
      try {
        const file = e.target.files[0]
        if (file.size / 1024 / 1024 > 5.2 * 1) {
          toast('上传图片不得大于5M，重新上传')
          return
        }
        const data = await fileToServer(file)
        console.log('data', data)

        emit('onCaptured', { ...data, imageKey: data.saveName })
      } catch (error) {}
    }
    return { uploadFile }
  },
  components: {},
}
</script>
<style lang="scss">
.upload {
  display: flex;
  .item-size {
    width: 152px;
    height: 152px;
    border-radius: 4px;
    margin-bottom: 20px;
    margin-right: 20px;
  }
  .item-size:nth-child(3n + 4) {
    margin-right: 0px !important;
  }
  .add-file {
    position: relative;
    // border: 1px dashed #000;
    background-image: url('../assets/file-add.png');
    background-size: 152px 152px;

    .upload-input {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      opacity: 0;
      z-index: 10;
    }
  }
  .file-item {
    .image {
      width: 100%;
      height: 100%;
    }
  }
}
</style>